module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("每日读片")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    slot: "title"
  }, [_vm._v("\n                 每日读片\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(" 每日读片的界面展示为日历形式，用户可提前进入操作当日（非当日数据不可操作）的读片事件，包括添加影像、病例、附件，在读片时，也可进行“互视客户端”的开启。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/28.png")
    }
  }), _vm._v(" "), _c('P', [_vm._v("点击【新建事件】，设定“重复周期”为“按周”，依次选择重复日、事件日期范围、事件时间，最后点击【确定】，完成新增。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/29.png")
    }
  }), _vm._v(" "), _c('P', [_c('b', {
    staticClass: "blod"
  }, [_vm._v("注：“重复周期”为“按周”时，选定的“周一周二…周日，在事件日期范围内，必需有1次满足，否则，将无法新增。")])]), _vm._v(" "), _c('P', [_vm._v("点击【新建事件】，在设定“重复周期”为“无”，依次选择事件日期范围、事件时间，最后点击【确定】，完成新增。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/30.png")
    }
  }), _vm._v(" "), _c('P', [_vm._v("点击【批量删除】，可删除指定时间内未开始的事件。")])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "进入会议影像/病例/附件添加"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("用户进入当日读片会议后，可以在影像模块的文本输入框内输入“病案号”、“检查号”进行影像数据的精确查询；也可在点击后"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/68.png")
    }
  })]), _vm._v("，进入影像库，如图-影像库，进行自由选择。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("在影像库中，勾选对应记录，点击【加入读片队列】，即可完成影像数据添加。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_c('b', {
    staticClass: "titleBar"
  }, [_vm._v("注：影像数据添加成功后可进行影像阅片、申请单查看等操作，不支持删除。")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/10.png")
    }
  })]), _vm._v(" "), _c('P', {
    staticStyle: {
      "margin-left": "35%"
    }
  }, [_vm._v("影像库")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户可以在病例模块的文本输入框内输入“病例名称”进行病例数据的模糊查询；也可在点击后"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/68.png")
    }
  })]), _vm._v("，进入病例库，进行自由选择。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("在病例库中，勾选对应记录，点击【加入读片队列】，即可完成病例数据添加。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_c('b', {
    staticClass: "titleBar"
  }, [_vm._v("注：病例数据添加成功后可查看病例详情，不支持删除。")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/23.png")
    }
  })]), _vm._v(" "), _c('P', {
    staticStyle: {
      "margin-left": "35%"
    }
  }, [_vm._v("病例库")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("“文档类型”添加")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于30M）。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("“图片类型”添加")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于3M）。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_c('b', {
    staticClass: "titleBar"
  }, [_vm._v("注：附件数据添加成功后可在线预览，不支持删除。")])])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3095d9a9","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/DailyReading/DailyReading.vue
// module id = 547
// module chunks = 1 2 3 4 5 6 7 8